export enum PrescriptionRequestStatusEnum {
  All = 0,
  InProgress,
  Pending,
  Finished,
}
